export default __webpack_public_path__ + "static/media/promos-icon-active.f4131953.webp";